"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.split");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

require("core-js/modules/es6.regexp.replace");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _searchRecommendation = _interopRequireDefault(require("./search-recommendation/search-recommendation"));

var _searchSuggestion = _interopRequireDefault(require("./search-suggestion/search-suggestion"));

var _searchNoResult = _interopRequireDefault(require("./search-no-result/search-no-result"));

var _searchLoading = _interopRequireDefault(require("./search-loading/search-loading"));

var _searchFunctions = require("./utils/search-functions");

var _recentlyViewedProductsFunctions = require("./utils/recently-viewed-products-functions");

var _helperUtils = require("./utils/helperUtils");

require("./search.css");

var _unstyledTextInput = _interopRequireDefault(require("@sfly/uig-styled-text-input/dist/core-js-3/unstyledTextInput"));

var _search2 = _interopRequireDefault(require("@sfly/uig-svg-icon/action/search"));

var _constants = require("./constants");

var _uigDeviceUtil = _interopRequireDefault(require("@sfly/uig-device-util"));

var _searchRecentlyViewed = _interopRequireDefault(require("./search-recently-viewed/search-recently-viewed"));

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var Search = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Search, _Component);

  var _super = _createSuper2(Search);

  function Search(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Search);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnKeyDown", function (e) {
      if ((0, _helperUtils.filterKeyPress)(e, [_helperUtils.keyCodeMap.escape])) {
        e.preventDefault();

        _this.setState({
          show: false
        }, function () {
          if (_this.textInputRef && _this.textInputRef.current) {
            _this.textInputRef.current.focus();
          }
        });
      } else if (e.target.type !== 'text' && (0, _helperUtils.filterKeyPress)(e, [_helperUtils.keyCodeMap.space])) {
        e.preventDefault();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchInput", function (e) {
      var maxLength = e.target.maxLength; // only block special characters %, ? and &

      var searchInput = e.target.value.slice(0, maxLength).replace(/[%?&]/gi, '') || '';

      _this.setState({
        searchVal: searchInput,
        originalSearchVal: searchInput,
        inputPlaceholder: 'Search'
      });

      var showState = !!searchInput; //setState are not guaranteed so calculating outside

      if (showState === true || !_this.state.recentlyViewedRes) {
        _this.setState({
          show: showState
        });
      }

      if (!searchInput) {
        _this.setState({
          suggestions: [],
          recommendations: [],
          loading: false
        });

        return;
      }

      _this.setState({
        loading: true,
        cursor: -1
      });

      _this.getAutoSuggest(searchInput);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAutoSuggest", function (query) {
      var self = (0, _assertThisInitialized2.default)(_this);

      _promise.default.resolve((0, _searchFunctions.getBloomreachSearchResult)(query).then(function (searchResults) {
        var _suggestions = [];
        var _recommendations = [];

        if (searchResults.response) {
          if (searchResults.response.suggestions && (0, _isArray.default)(searchResults.response.suggestions)) {
            _suggestions = searchResults.response.suggestions.length > 10 ? searchResults.response.suggestions.slice(0, 10) : searchResults.response.suggestions;
          }

          if (searchResults.response.products && (0, _isArray.default)(searchResults.response.products)) {
            _recommendations = searchResults.response.products.length > 5 ? searchResults.response.products.slice(0, 5) : searchResults.response.products;
          }
        } // if no suggestion items returned on mobile don't show dropdown


        if ((0, _helperUtils.isMobileDevice)() && _suggestions.length === 0) {
          self.setState({
            show: false
          });
        }

        self.setState({
          suggestions: _suggestions,
          recommendations: _recommendations,
          loading: false
        });
      })).catch(function (err) {
        self.setState({
          loading: false
        }); // Try to call autosuggest again to fall back to solr.

        _this.getAutoSuggest(err.message);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", function (e) {
      e.preventDefault();

      if (_this.props.onSubmitCB && typeof _this.props.onSubmitCB === 'function') {
        _this.props.onSubmitCB(_this.state.searchVal);
      }

      if (_this.state.searchVal.trim() !== '') {
        if (typeof window !== 'undefined') {
          //skip redirect if searching string is empty
          window.location.assign((0, _searchFunctions.redirectSiteSearch)(_this.state.searchVal));
        }
      } else {
        _this.setState({
          inputPlaceholder: 'Enter a search term'
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (e) {
      var _this$state = _this.state,
          cursor = _this$state.cursor,
          suggestions = _this$state.suggestions,
          recommendations = _this$state.recommendations;
      var combinedList = [].concat((0, _toConsumableArray2.default)(suggestions), (0, _toConsumableArray2.default)(recommendations));
      var listLength = combinedList.length;

      if (_this.state.searchVal && _this.state.searchVal.trim() !== '') {
        // arrow up/down button should select next/previous list element
        if (e.keyCode === 40 && cursor < 0) {
          _this.setState({
            cursor: 0
          }, function () {
            return _this.updateInputFieldValue();
          });
        } else if (e.keyCode === 38 && cursor === 0) {
          e.preventDefault();

          _this.setState({
            cursor: listLength - 1
          }, function () {
            return _this.updateInputFieldValue();
          });
        } else if (e.keyCode === 38 && cursor > 0) {
          e.preventDefault();

          _this.setState(function (prevState) {
            return {
              cursor: prevState.cursor - 1
            };
          }, function () {
            return _this.updateInputFieldValue();
          });
        } else if (e.keyCode === 40 && cursor < listLength - 1) {
          e.preventDefault();

          _this.setState(function (prevState) {
            return {
              cursor: prevState.cursor + 1
            };
          }, function () {
            return _this.updateInputFieldValue();
          });
        } else if (e.keyCode === 40 && cursor === listLength - 1) {
          e.preventDefault();

          _this.setState({
            cursor: -1
          }, function () {
            return _this.updateInputFieldValue();
          });
        } else if (e.keyCode === 27) {
          e.preventDefault();

          _this.setState({
            show: false
          });
        }
      } else if (e.keyCode === 32) {
        e.preventDefault();

        _this.setState({
          inputPlaceholder: 'Enter a search term'
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateInputFieldValue", function () {
      var _this$state2 = _this.state,
          cursor = _this$state2.cursor,
          suggestions = _this$state2.suggestions,
          recommendations = _this$state2.recommendations;

      if (cursor >= 0 && cursor < suggestions.length) {
        _this.setState({
          searchVal: suggestions[cursor].q
        });
      } else if (cursor >= suggestions.length && cursor < suggestions.length + recommendations.length) {
        _this.setState({
          searchVal: recommendations[cursor - suggestions.length].displayName
        });
      } else {
        _this.setState({
          searchVal: _this.state.originalSearchVal
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOutsideClick", function (e) {
      var currentTarget = e.currentTarget;
      var self = (0, _assertThisInitialized2.default)(_this);
      setTimeout(function () {
        // using setTimeout to avoid blocking the execution cycle
        if (!currentTarget.contains(document.activeElement)) {
          self.setState({
            show: false
          });
        }
      }, 0); // set placeholder text back to Search when form loses focus

      _this.setState({
        inputPlaceholder: 'Search'
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownBuilder", function (content) {
      return _react.default.createElement("ul", {
        className: !_this.state.show ? 'autocomplete-container hide' : 'autocomplete-container',
        id: "search_results",
        role: "listbox"
      }, content);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateCursor", function (value) {
      _this.setState({
        cursor: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeInfoAfterDelimiter", function (label) {
      var removeInfoAfterDelimiter = label && label.split('|');
      return removeInfoAfterDelimiter && removeInfoAfterDelimiter[0];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contentBuilder", function () {
      var recentlyViewedRes = _this.state.recentlyViewedRes;
      var hasSuggestions = _this.state.suggestions.length > 0;
      var isMobile = (0, _helperUtils.isMobileDevice)();
      var hasRecommendations = _this.state.recommendations.length > 0;
      var showRecentlyViewedProd = recentlyViewedRes && _this.state.searchVal.trim() === '';

      if (showRecentlyViewedProd) {
        var displayCount = isMobile ? _constants.RECENTLY_VIEWED_CONFIG.DISPLAY_ITEM_COUNT.MOBILE : _constants.RECENTLY_VIEWED_CONFIG.DISPLAY_ITEM_COUNT.DESKTOP;
        var recentlyViewedList = recentlyViewedRes.slice(0, displayCount);
        return _this.dropdownBuilder([_react.default.createElement("li", {
          className: "autocomplete-header suggestion recently-viewed ".concat(_this.disableAutoZoomCss),
          id: "recently-viewed-header",
          key: "recently_viewed_header"
        }, _react.default.createElement("div", null, _constants.RECENTLY_VIEWED), _react.default.createElement("button", {
          onClick: _this.handleClearAll,
          "data-linkname": "clear all"
        }, _constants.CLEAR_ALL)), recentlyViewedList.map(function (result, index) {
          return _react.default.createElement(_searchRecentlyViewed.default, {
            imageUrl: result.thumb_image,
            prodLabel: result.prod_name,
            targetUrl: result.url,
            key: index,
            tabindex: "0" // cursor={this.state.cursor}
            // onMouseEnter={this.updateCursor}
            // onMouseLeave={this.updateCursor}
            ,
            categoryName: result.category && result.category.name,
            categoryLink: result.category && result.category.destinationUri,
            productName: result && result.name,
            productLink: result.productInfoPageUri,
            productThumbnail: result.imageUrls && result.imageUrls.thumbnailUrl,
            productCode: result && result.productCode,
            sku: result && result.sku,
            subCategory: result && result.parentCategory && result.parentCategory.name,
            brand: result && result.brand,
            categoryCode: result && result.category && result.category.categoryCode
          });
        })]);
      }

      if (_this.state.loading) {
        return _this.dropdownBuilder(_react.default.createElement(_searchLoading.default, null));
      }

      if (!_this.state.loading && !hasRecommendations && !hasSuggestions) {
        return _this.dropdownBuilder(_react.default.createElement(_searchNoResult.default, null));
      }

      if (hasRecommendations || hasSuggestions) {
        return _this.dropdownBuilder([hasSuggestions ? _react.default.createElement("li", {
          className: "autocomplete-header suggestion ".concat(_this.disableAutoZoomCss),
          id: "search-dropdown-suggestion-header",
          key: "sug_head"
        }, _constants.COMMON_SEARCHES) : null, _this.state.suggestions.map(function (suggestion, index) {
          return (// eslint-disable-next-line react/jsx-indent
            _react.default.createElement(_searchSuggestion.default, {
              label: suggestion.q || suggestion //sometime observed suggestion.q is undefined
              ,
              key: suggestion.q || suggestion,
              index: index,
              searchStr: _this.state.searchVal,
              tabindex: "0",
              onKeyDown: _this.handleOnKeyDown,
              cursor: _this.state.cursor,
              onMouseEnter: _this.updateCursor,
              onMouseLeave: _this.updateCursor
            })
          );
        }), // check for mobile device if mobile device don't show recommendations
        hasRecommendations > 0 && !isMobile ? _react.default.createElement("li", {
          className: "autocomplete-header recommendation ".concat(_this.disableAutoZoomCss),
          id: "search-dropdown-recommendation-header",
          key: "rec_head",
          onKeyDown: _this.handleOnKeyDown
        }, _constants.RECOMMENDED) : null, _this.state.recommendations.map(function (result, index) {
          return (// eslint-disable-next-line react/jsx-indent
            // check for mobile device if mobile device don't show recommendations
            !isMobile ? _react.default.createElement(_searchRecommendation.default, {
              imageUrl: result.thumb_image,
              label: _this.removeInfoAfterDelimiter(result.displayName),
              targetUrl: result.url,
              key: result.pid,
              index: index + _this.state.suggestions.length,
              searchStr: _this.state.searchVal,
              tabindex: "0",
              onKeyDown: _this.handleOnKeyDown,
              cursor: _this.state.cursor,
              onMouseEnter: _this.updateCursor,
              onMouseLeave: _this.updateCursor
            }) : null
          );
        })]);
      }

      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputBoxFocus", function () {
      var recentlyViewedRes = _this.state.recentlyViewedRes;

      if (!_this.state.recentlyViewedRes && _this.recentlyViewedAPIConfig) {
        (0, _recentlyViewedProductsFunctions.fetchRecentlyViewedProducts)(_this.recentlyViewedAPIConfig).then(function (response) {
          if (response && (0, _isArray.default)(response)) {
            _this.onRecentlyViewedOverlayOpen();

            _this.setState({
              recentlyViewedRes: response,
              show: true
            });
          }
        });
      } else if (recentlyViewedRes && !_this.state.show) {
        _this.onRecentlyViewedOverlayOpen();

        _this.setState({
          show: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRecentlyViewedOverlayOpen", function () {
      (0, _recentlyViewedProductsFunctions.triggerAnalyticsEvents)({
        event: {
          eventDetails: {
            overlayName: 'Recently Viewed - Index'
          },
          eventInfo: {
            eventName: 'recentlyViewedOverlay'
          }
        }
      });
    });
    _this.state = {
      recommendations: [],
      suggestions: [],
      show: false,
      searchVal: '',
      originalSearchVal: '',
      loading: true,
      cursor: -1,
      inputPlaceholder: 'Search',
      recentlyViewedRes: null
    };

    _this.getAutoSuggest.bind((0, _assertThisInitialized2.default)(_this));

    _this.handleOnKeyDown = _this.handleOnKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClearAll = _this.handleClearAll.bind((0, _assertThisInitialized2.default)(_this));
    _this.getAutoSuggest = (0, _debounce.default)(_this.getAutoSuggest, 500);
    _this.textInputRef = _react.default.createRef();
    _this.isIOSDevice = _uigDeviceUtil.default.ios();
    _this.disableAutoZoomCss = _this.isIOSDevice ? 'autoZoomDisable' : '';
    _this.recentlyViewedAPIConfig = {
      brandType: props.brandType
    };
    _this.uigSearchWrapperRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(Search, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.jwtToken !== prevProps.jwtToken || this.props.user !== prevProps.user) {
        if (!(this.props.user === 'Not Authenticated' && !this.props.jwtToken)) {
          this.recentlyViewedAPIConfig.jwtToken = this.props.jwtToken;
          this.recentlyViewedAPIConfig.userId = this.props.user.sfly_uid;
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.uigSearchWrapperRef && !this.uigSearchWrapperRef.current.contains(event.target)) {
        this.setState({
          show: false
        });
      }

      this.setState({
        inputPlaceholder: 'Search'
      });
    }
  }, {
    key: "handleClearAll",
    value: function () {
      var _handleClearAll = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var config, res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = {
                  brandType: this.props.brandType
                };

                if (this.props.jwtToken && this.props.user && this.props.user.sfly_uid) {
                  config.jwtToken = this.props.jwtToken;
                  config.userId = this.props.user.sfly_uid;
                }

                _context.next = 4;
                return (0, _recentlyViewedProductsFunctions.deleteRecentlyViewedProducts)(config);

              case 4:
                res = _context.sent;

                if (res) {
                  this.setState({
                    recentlyViewedRes: null,
                    show: false
                  });
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleClearAll() {
        return _handleClearAll.apply(this, arguments);
      }

      return handleClearAll;
    }()
  }, {
    key: "render",
    value: function render() {
      var cursor = this.state.cursor;
      var currentOptionId = cursor >= 0 ? "option-".concat(cursor) : '';
      return _react.default.createElement("div", {
        className: "uig-search",
        onKeyDown: this.handleOnKeyDown,
        ref: this.uigSearchWrapperRef
      }, _react.default.createElement("form", {
        className: "uigSrchFieldContainer",
        onSubmit: this.handleSubmit,
        id: this.props.formID || 'searchBar'
      }, _react.default.createElement("div", {
        className: "uigSrchTxtFieldContainer"
      }, _react.default.createElement(_unstyledTextInput.default, (0, _extends2.default)({
        placeholder: this.state.inputPlaceholder,
        value: this.state.searchVal,
        onChange: this.handleSearchInput,
        className: "uigSrchTxtField ".concat(this.disableAutoZoomCss),
        "aria-label": 'Enter searching text here',
        onKeyDown: this.handleKeyDown,
        maxLength: 50,
        inputRef: this.textInputRef,
        role: "searchbox",
        "aria-autocomplete": "list",
        "aria-owns": "search_results",
        "aria-activedescendant": currentOptionId,
        onFocus: this.onInputBoxFocus
      }, this.props.dataLinkName && {
        'data-linkname': this.props.dataLinkName
      }))), _react.default.createElement("button", {
        "aria-label": 'Go to search result',
        style: {
          cursor: 'pointer'
        }
      }, _react.default.createElement(_search2.default, {
        className: "srch_go",
        fill: "#58595b"
      }))), this.contentBuilder());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var reset = _ref.reset,
          jwtToken = _ref.jwtToken,
          user = _ref.user;

      if (reset && state.searchVal !== '') {
        return {
          searchVal: '',
          originalSearchVal: ''
        };
      }

      if (jwtToken !== state.jwtToken || user !== state.user) {
        return {
          jwtToken: jwtToken,
          user: user
        };
      }

      return null;
    }
  }]);
  return Search;
}(_react.Component);

exports.default = Search;
Search.propTypes = {
  onSubmitCB: _propTypes.default.func,
  formID: _propTypes.default.string,
  // eslint-disable-next-line react/no-unused-prop-types
  reset: _propTypes.default.bool,
  jwtToken: _propTypes.default.string,
  user: _propTypes.default.any,
  // eslint-disable-next-line react/no-unused-prop-types
  brandType: _propTypes.default.string,
  dataLinkName: _propTypes.default.string
};
Search.defaultProps = {
  onSubmitCB: function onSubmitCB() {},
  formID: 'searchBar',
  reset: false,
  jwtToken: null,
  user: null,
  brandType: 'SFLY',
  dataLinkName: ''
};